import { StrictMode } from "react";
import ReactDOM from "react-dom";
import ApolloProvider from "./context/ApolloProvider";
import reportWebVitals from "./reportWebVitals";

import "./styles/index.scss";

ReactDOM.render(
  <StrictMode>{ApolloProvider}</StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
